module.exports = __webpack_public_path__ + "static/img/default_head_img.74cfa22a.png";